// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.1.10_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.1_f4893ebf28ed7f924e57e0016ea700de/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.1.10_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.1_f4893ebf28ed7f924e57e0016ea700de/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HqMdsLKqMaYRnka9 {
	outline: none;

	&[data-focus-visible] {
		outline: 2px solid var(--lp-color-shadow-interactive-focus);
		outline-offset: -2px;
		z-index: 1;
	}
}

.DXrqAkuZnuI0A_VU {
	&[data-orientation='horizontal'] {
		& :where(button, a, label):first-child:not(:only-child) {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}

		& :where(button, a, label):last-child:not(:only-child) {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
		}

		& :where(button, a, label):not(:first-child) {
			margin-inline-start: -1px;
		}

		& :where(button, a, label):not(:first-child):not(:last-child) {
			border-radius: 0;
		}
	}

	&[data-orientation='vertical'] {
		& :where(button, a, label):first-child:not(:only-child) {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}

		& :where(button, a, label):last-child:not(:only-child) {
			border-top-left-radius: 0;
			border-top-right-radius: 0;
		}

		& :where(button, a, label):not(:first-child):not([role='separator']) {
			margin-block-start: -1px;
		}

		& :where(button, a, label):not(:first-child):not(:last-child) {
			border-radius: 0;
		}
	}
}

.M9x05lQXUcw6In8C {
	cursor: pointer;

	&[data-disabled] {
		cursor: not-allowed;
	}
}

.XdEXUDQMeQW55Yp5 {
	&:is(input, textarea) {
		cursor: text;
	}

	&[data-disabled] {
		cursor: not-allowed;
	}
}

.dMdpNYM8Q8gq4WWW {
	&[data-selection-mode],
	&[data-href] {
		cursor: pointer;
	}

	&[data-disabled][data-selection-mode] {
		cursor: not-allowed;
	}
}

[data-lp][aria-disabled='true'] {
	opacity: 0.64;
	cursor: default;
}

.JYCz41ZFehUuH8Q9 {
	border-color: var(--lp-color-border-field-error);
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/base.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;;CAEb;EACC,2DAA2D;EAC3D,oBAAoB;EACpB,UAAU;CACX;AACD;;AAEA;CACC;EACC;GACC,0BAA0B;GAC1B,6BAA6B;EAC9B;;EAEA;GACC,yBAAyB;GACzB,4BAA4B;EAC7B;;EAEA;GACC,yBAAyB;EAC1B;;EAEA;GACC,gBAAgB;EACjB;CACD;;CAEA;EACC;GACC,4BAA4B;GAC5B,6BAA6B;EAC9B;;EAEA;GACC,yBAAyB;GACzB,0BAA0B;EAC3B;;EAEA;GACC,wBAAwB;EACzB;;EAEA;GACC,gBAAgB;EACjB;CACD;AACD;;AAEA;CACC,eAAe;;CAEf;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;;EAEC,eAAe;CAChB;;CAEA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,gDAAgD;AACjD","sourcesContent":[".focus {\n\toutline: none;\n\n\t&[data-focus-visible] {\n\t\toutline: 2px solid var(--lp-color-shadow-interactive-focus);\n\t\toutline-offset: -2px;\n\t\tz-index: 1;\n\t}\n}\n\n.buttonGroup {\n\t&[data-orientation='horizontal'] {\n\t\t& :where(button, a, label):first-child:not(:only-child) {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t& :where(button, a, label):last-child:not(:only-child) {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t& :where(button, a, label):not(:first-child) {\n\t\t\tmargin-inline-start: -1px;\n\t\t}\n\n\t\t& :where(button, a, label):not(:first-child):not(:last-child) {\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\n\t&[data-orientation='vertical'] {\n\t\t& :where(button, a, label):first-child:not(:only-child) {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t& :where(button, a, label):last-child:not(:only-child) {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-top-right-radius: 0;\n\t\t}\n\n\t\t& :where(button, a, label):not(:first-child):not([role='separator']) {\n\t\t\tmargin-block-start: -1px;\n\t\t}\n\n\t\t& :where(button, a, label):not(:first-child):not(:last-child) {\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n}\n\n.interactive {\n\tcursor: pointer;\n\n\t&[data-disabled] {\n\t\tcursor: not-allowed;\n\t}\n}\n\n.field {\n\t&:is(input, textarea) {\n\t\tcursor: text;\n\t}\n\n\t&[data-disabled] {\n\t\tcursor: not-allowed;\n\t}\n}\n\n.selectable {\n\t&[data-selection-mode],\n\t&[data-href] {\n\t\tcursor: pointer;\n\t}\n\n\t&[data-disabled][data-selection-mode] {\n\t\tcursor: not-allowed;\n\t}\n}\n\n:global([data-lp][aria-disabled='true']) {\n\topacity: 0.64;\n\tcursor: default;\n}\n\n.invalid {\n\tborder-color: var(--lp-color-border-field-error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"focus": `HqMdsLKqMaYRnka9`,
	"buttonGroup": `DXrqAkuZnuI0A_VU`,
	"interactive": `M9x05lQXUcw6In8C`,
	"field": `XdEXUDQMeQW55Yp5`,
	"selectable": `dMdpNYM8Q8gq4WWW`,
	"invalid": `JYCz41ZFehUuH8Q9`
};
export default ___CSS_LOADER_EXPORT___;
